module.exports = __webpack_public_path__ + "img/1508626102.dc9fce5a.jpg";